import axios from "axios";

export let headers = {
  "Tenant-Access-Token": "ZTcyOWM2MTY4ZjFmYWE2MzkwZjNhYzQxMzEwNTNiZGI=",
  "Tenant-Access-Key": "bC61XPrh3iFVQA",
};

export const BASE_URL = "https://immersive-game-india.confirmu.com";

export const api = axios.create({
  baseURL: BASE_URL,
  headers: headers,
});
